module.exports = __webpack_public_path__ + "static/img/bg_home_ep_title.d3bbae2c.png";